// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.videos_mainContainer__4r\\+xP {
  .videos_rowTitle__KuEi\\+ {
    .videos_colTitle__pHQT0 {
      .videos_title__rHIvc {
        font-size: clamp(2rem, 5vw, 3.75rem);
        font-weight: bolder;
        text-align: center;
      }
    }
  }

  .videos_rowSubtitle__m-hFY {
    .videos_colSubtitle__jdn1H {
      .videos_subtitle__An0yp {
        font-size: clamp(1.5rem, 3vw, 2rem);
        text-align: center;
        color: #3a3a3a;
      }
    }
  }

  .videos_rowContent__7k1KV {
    height: auto;
    justify-content: space-evenly;
    .videos_colDetail__IeJ\\+- {
      height: inherit;
      background-color: #e7e7e7;
      border-radius: 12px;
      border: 2px #dedede solid;
      .videos_rowDetailTitle__h6Ri5 {
        .videos_colDetailTitle__oO-dA {
          font-size: clamp(1.5rem, 2.3vw, 2rem);
        }
      }
    }
    .videos_colVideo__Tl6Sp {
      height: inherit;
      background-color: #e7e7e7;
      border-radius: 12px;
      border: 2px #dedede solid;
      .videos_rowVideoTitle__lzQeJ {
        .videos_colVideoTitle__9\\+P7H {
          h2 {
            font-size: clamp(1.5rem, 2.3vw, 2rem);
          }
        }
      }
    }
  }

  .videos_rowForm__2N9uE {
    height: auto;
    .videos_colForm__gTJNG {
      height: 100%;
      background-color: #e7e7e7;
      border-radius: 12px;
      border: 2px #dedede solid;
      .videos_rowFormTitle__y8iBk {
        .videos_colFormTitle__IzEhG {
          font-size: clamp(1.5rem, 2.3vw, 2rem);
        }
      }
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/contents/videos/videos.module.css"],"names":[],"mappings":"AAAA;EACE;IACE;MACE;QACE,oCAAoC;QACpC,mBAAmB;QACnB,kBAAkB;MACpB;IACF;EACF;;EAEA;IACE;MACE;QACE,mCAAmC;QACnC,kBAAkB;QAClB,cAAc;MAChB;IACF;EACF;;EAEA;IACE,YAAY;IACZ,6BAA6B;IAC7B;MACE,eAAe;MACf,yBAAyB;MACzB,mBAAmB;MACnB,yBAAyB;MACzB;QACE;UACE,qCAAqC;QACvC;MACF;IACF;IACA;MACE,eAAe;MACf,yBAAyB;MACzB,mBAAmB;MACnB,yBAAyB;MACzB;QACE;UACE;YACE,qCAAqC;UACvC;QACF;MACF;IACF;EACF;;EAEA;IACE,YAAY;IACZ;MACE,YAAY;MACZ,yBAAyB;MACzB,mBAAmB;MACnB,yBAAyB;MACzB;QACE;UACE,qCAAqC;QACvC;MACF;IACF;EACF;AACF","sourcesContent":[".mainContainer {\n  .rowTitle {\n    .colTitle {\n      .title {\n        font-size: clamp(2rem, 5vw, 3.75rem);\n        font-weight: bolder;\n        text-align: center;\n      }\n    }\n  }\n\n  .rowSubtitle {\n    .colSubtitle {\n      .subtitle {\n        font-size: clamp(1.5rem, 3vw, 2rem);\n        text-align: center;\n        color: #3a3a3a;\n      }\n    }\n  }\n\n  .rowContent {\n    height: auto;\n    justify-content: space-evenly;\n    .colDetail {\n      height: inherit;\n      background-color: #e7e7e7;\n      border-radius: 12px;\n      border: 2px #dedede solid;\n      .rowDetailTitle {\n        .colDetailTitle {\n          font-size: clamp(1.5rem, 2.3vw, 2rem);\n        }\n      }\n    }\n    .colVideo {\n      height: inherit;\n      background-color: #e7e7e7;\n      border-radius: 12px;\n      border: 2px #dedede solid;\n      .rowVideoTitle {\n        .colVideoTitle {\n          h2 {\n            font-size: clamp(1.5rem, 2.3vw, 2rem);\n          }\n        }\n      }\n    }\n  }\n\n  .rowForm {\n    height: auto;\n    .colForm {\n      height: 100%;\n      background-color: #e7e7e7;\n      border-radius: 12px;\n      border: 2px #dedede solid;\n      .rowFormTitle {\n        .colFormTitle {\n          font-size: clamp(1.5rem, 2.3vw, 2rem);\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainContainer": `videos_mainContainer__4r+xP`,
	"rowTitle": `videos_rowTitle__KuEi+`,
	"colTitle": `videos_colTitle__pHQT0`,
	"title": `videos_title__rHIvc`,
	"rowSubtitle": `videos_rowSubtitle__m-hFY`,
	"colSubtitle": `videos_colSubtitle__jdn1H`,
	"subtitle": `videos_subtitle__An0yp`,
	"rowContent": `videos_rowContent__7k1KV`,
	"colDetail": `videos_colDetail__IeJ+-`,
	"rowDetailTitle": `videos_rowDetailTitle__h6Ri5`,
	"colDetailTitle": `videos_colDetailTitle__oO-dA`,
	"colVideo": `videos_colVideo__Tl6Sp`,
	"rowVideoTitle": `videos_rowVideoTitle__lzQeJ`,
	"colVideoTitle": `videos_colVideoTitle__9+P7H`,
	"rowForm": `videos_rowForm__2N9uE`,
	"colForm": `videos_colForm__gTJNG`,
	"rowFormTitle": `videos_rowFormTitle__y8iBk`,
	"colFormTitle": `videos_colFormTitle__IzEhG`
};
export default ___CSS_LOADER_EXPORT___;
